import { Box, TextField } from '@mui/material';
import { Create } from '@refinedev/mui';
import { useForm } from '@refinedev/react-hook-form';

import { ATTACKIQ_ID } from '@attackiq/constants/platform';

const ReportTypeCreate = () => {
  const {
    refineCore: { formLoading },
    register,
    saveButtonProps,
    formState: { errors }
  } = useForm();

  return (
    <Create isLoading={formLoading} saveButtonProps={saveButtonProps}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column'
        }}
        component="form"
        autoComplete="off"
      >
        <TextField
          {...register('name', { required: 'Report type name is required' })}
          error={!!errors.name}
          helperText={errors.name?.message as string}
          margin="normal"
          required
          id="name"
          name="name"
          label="Report type name"
          fullWidth
          autoFocus
        />

        <TextField
          {...register('template_path', { required: 'This field is required' })}
          error={!!errors.template_path}
          helperText={errors.template_path?.message as string}
          label="Report"
          fullWidth
          required
          multiline
          minRows={5}
          maxRows={10}
        />
        <input
          type="hidden"
          {...register('company', {
            value: ATTACKIQ_ID
          })}
        />
      </Box>
    </Create>
  );
};

export default ReportTypeCreate;
